export const RuleValueType = {
  String: 'string',
  Regex: 'regex',
};

export const RuleValueTypes = [
  { label: 'String', value: RuleValueType.String },
  { label: 'Regex', value: RuleValueType.Regex },
];

export const RuleCondition = {
  Subject: {
    contains: 'subject-contains',
    notContains: 'subject-not-contains',
  },
  Body: {
    contains: 'body-contains',
    notContains: 'body-not-contains',
  },
};

export const RuleConditions = [
  { label: 'Subject Contains', value: RuleCondition.Subject.contains },
  { label: 'Subject Does Not Contain', value: RuleCondition.Subject.notContains },
  { label: 'Body Contains', value: RuleCondition.Body.contains },
  { label: 'Body Does Not Contain', value: RuleCondition.Body.notContains },
];
